import { useEffect } from 'react';
import styled from '@emotion/styled';
import { Icon, Modal } from 'semantic-ui-react';

const PreviewBody = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 12rem;

  img {
    display: block;
    max-width: 100%;
    max-height: calc(100vh - 8rem);
    margin: 0 auto;
    object-fit: contain;
  }

  .catalog-preview__nav {
    position: absolute;
    top: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2.5rem;
    height: 2.5rem;
    margin: 0;
    padding: 0;
    border: none;
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.92);
    color: #191919;
    transform: translateY(-50%);
    cursor: pointer;

    i.icon {
      margin: 0;
    }
  }

  .catalog-preview__nav--prev {
    left: 0;
  }

  .catalog-preview__nav--next {
    right: 0;
  }

  .catalog-preview__count {
    position: absolute;
    left: 50%;
    bottom: -1.75rem;
    margin: 0;
    color: #ffffff;
    font-size: 0.85rem;
    transform: translateX(-50%);
  }
`;

const CatalogPhotoPreview = ({ photos, index, businessName, onClose, onIndexChange }) => {
  const open = index != null && Boolean(photos[index]);

  useEffect(() => {
    if (!open || photos.length < 2) return undefined;

    const onKeyDown = (event) => {
      if (event.key === 'ArrowRight') {
        onIndexChange((current) => (current + 1) % photos.length);
      }
      if (event.key === 'ArrowLeft') {
        onIndexChange((current) => (current - 1 + photos.length) % photos.length);
      }
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open, photos.length, onIndexChange]);

  const showPreviousPhoto = () => {
    onIndexChange((current) => (current - 1 + photos.length) % photos.length);
  };

  const showNextPhoto = () => {
    onIndexChange((current) => (current + 1) % photos.length);
  };

  return (
    <Modal
      basic
      closeIcon
      open={open}
      onClose={onClose}
      size="large"
      aria-label={`Vista previa del catálogo de ${businessName || 'la empresa'}`}
    >
      <Modal.Content>
        <PreviewBody>
          {photos.length > 1 && (
            <button
              type="button"
              className="catalog-preview__nav catalog-preview__nav--prev"
              aria-label="Foto anterior"
              onClick={showPreviousPhoto}
            >
              <Icon name="chevron left" />
            </button>
          )}
          {open && (
            <img
              src={photos[index]}
              alt={`Foto ${index + 1} del catálogo de ${businessName || 'la empresa'}`}
            />
          )}
          {photos.length > 1 && (
            <button
              type="button"
              className="catalog-preview__nav catalog-preview__nav--next"
              aria-label="Foto siguiente"
              onClick={showNextPhoto}
            >
              <Icon name="chevron right" />
            </button>
          )}
          {photos.length > 1 && open && (
            <p className="catalog-preview__count">
              {index + 1} / {photos.length}
            </p>
          )}
        </PreviewBody>
      </Modal.Content>
    </Modal>
  );
};

export default CatalogPhotoPreview;
